export const dialogflowPayload = {
  questionTypes: {
    button: 'button',
    freeformText: 'freeformText',
    textSkip: 'textSkip',
  },
};
